/* eslint-disable */
import React from 'react';
import Tooltip from 'src/components/common/tooltip/Tooltip';
import './styles.scss';

export const InputCheckbox = ({ value, className = '', onClick, tooltip = null }) => {
  return (
    <Tooltip content={tooltip} disabled={!tooltip}>
      <span
        className={`${value ? `approve-label ${className} checked` : `approve-label ${className}`}`}
        onClick={onClick}
      />
    </Tooltip>
  );
};
